export default defineNuxtRouteMiddleware(async () => {
    const {user, isLoggedIn} = useAuthStore();
    if(!isLoggedIn) return;
    if (!user?.is_verified) return navigateTo({name: 'onboarding'}, {replace: true});
    if (!user?.is_age_verified) return navigateTo({name: 'onboarding'}, {replace: true});
});